// Code lookup utilities — extracted from MyScripts/Utils.ts
import { Codes } from '@/constants/codes';

const WarningPriorities = (window as any).WarningPriorities;

export function getCodes(id: any, codeType: Array<{ code: any, value: string }>): { code: any, value: string } | undefined {
  if (id == null) return undefined;
  return codeType.find(o => (o.code != null && o.code.toString() === id.toString()));
}

export function getCallDisposition(code: number) {
  return Codes.getDispositionCodes().find((o: any) => (o.code === code));
}

export function getWarningPriority(code: number) {
  return WarningPriorities.find(o => (o.code === code));
}

export function getGender(code: number) {
  return Codes.getGenderCodes().find((o: any) => (o.code === code));
}

export function getRace(code: number) {
  return Codes.getRaceCodes().find((o: any) => (o.code === code));
}

export function getEyeColor(code: number) {
  return Codes.getEyeColorCodes().find((o: any) => (o.code === code));
}

export function getHairColor(code: number) {
  return Codes.getHairColorCodes().find((o: any) => (o.code === code));
}

export function getP2PRelationship(code: number) {
  return Codes.getRelationshipTypes().find((o: any) => (o.code === code));
}

export function getVehicleType(code: number) {
  return Codes.getVehicleTypes().find((o: any) => (o.code === code));
}

export function getNotifiedAs(code: number) {
  return Codes.getNotifiedPersonAsCodes().find((o: any) => (o.code === code));
}

export function getNotifiedOfIncident(code: number) {
  return Codes.getHowReceivedCodes().find((o: any) => (o.code === code));
}

export function getPersonRole(code: number) {
  return Codes.getPersonCodes().find((o: any) => (o.code === code));
}

export function getOffense(code: number) {
  return Codes.getOffenseCodes().find((o: any) => (o.code === code));
}

export function getReportedAs(code: number) {
  return Codes.getPropertyCodes().find((o: any) => (o.code === code));
}

export function getEvidenceOf(code: number) {
  return Codes.getDigitalEvidenceCodes().find((o: any) => (o.code === code));
}
